import { render, staticRenderFns } from "./CampaignMatchesFilters.vue?vue&type=template&id=8f40b1e0"
import script from "./CampaignMatchesFilters.vue?vue&type=script&lang=js"
export * from "./CampaignMatchesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports